<template>
    <div class="page-pricing-guide">
        <div class="jumbo-wrapper product-guide">
            <div class="jumbo-main">
                <div class="jumbo-content">
                    <p class="t15">PRODUCT GUIDE</p>
                    <h2 class="t42">
                        BRICKS, TILES &amp;
                        <br/>
                        ENGRAVING OPTIONS
                    </h2>
                    <p class="t20">Our colors and sizes are well-suited for any location.</p>
                </div>
            </div>
        </div>
        <div class="box-content">
            <div class="box-content-inner">
                <div class="row checkbox-list">
                    <div class="col-sm-6 col-xs-12 col-md-3 text-center">
                        <div class="icon-box">
                            <img src="images/checkbox.png" alt="">
                        </div>
                        <p class="heading">
                            NO<br/>
                            UPFRONT COSTS
                        </p>
                    </div>
                    <div class="col-sm-6 col-xs-12 col-md-3 text-center">
                        <div class="icon-box">
                            <img src="images/checkbox.png" alt="">
                        </div>
                        <p class="heading">
                            NO<br/>
                            MINIMUM ORDER
                        </p>
                    </div>
                    <div class="col-sm-6 col-xs-12 col-md-3 text-center">
                        <div class="icon-box">
                            <img src="images/checkbox.png" alt="">
                        </div>
                        <p class="heading">
                            FREE<br/>
                            SHIPPING
                        </p>
                    </div>
                    <div class="col-sm-6 col-xs-12 col-md-3 text-center">
                        <div class="icon-box">
                            <img src="images/checkbox.png" alt="">
                        </div>
                        <p class="heading">
                            FREE PERSONALIZED
                            <br/>
                            MARKETING SAMPLE!
                        </p>
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="pricing-area">
                    <div class="body-area-headline">BRICKS</div>
                    <p>
                        Engraved brick pricing is based on your total order quantity per material and size. Pricing includes the cost of material, engraving, and freight within the contiguous United States.
                    </p>
                    <div class="pricing-area-images">
                        <img width="832" height="779" class="img-responsive desktop" src="images/Pricing-Guide/pricingguide01.png" alt="">
                        <img class="img-responsive mobile" src="images/Pricing-Guide/mobileregred.png" alt="Regimental Red">
                        <img class="img-responsive mobile" src="images/Pricing-Guide/mobileclaret.png" alt="Claret Full Range">
                        <img class="img-responsive mobile" src="images/Pricing-Guide/mobilelandgray.png" alt="Landmark Gray">
                        <img class="img-responsive mobile" src="images/Pricing-Guide/mobileironspotbrick.png" alt="Medium Ironspot">
                        <img class="img-responsive mobile" src="images/Pricing-Guide/mobilemesabi.png" alt="Mesabi Granite">
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="pricing-area">
                    <div class="body-area-headline">TILES</div>
                    <p>
                        Engraved tile pricing is based on your total order quantity per material and size. Pricing includes the cost of material, engraving, and freight within the contiguous United States.
                    </p>
                    <div class="pricing-area-images">
                        <img width="831" height="518" class="img-responsive desktop" src="images/Pricing-Guide/pricingguide02.png" alt="">
                        <img class="img-responsive mobile" src="images/Pricing-Guide/mobileredblend.png" alt="Red Blend">
                        <img class="img-responsive mobile" src="images/Pricing-Guide/mobileironspottile.png" alt="Medium Ironspot">
                        <img class="img-responsive mobile" src="images/Pricing-Guide/mobilemanganese.png" alt="Manganese">
                        <img class="img-responsive mobile" src="images/Pricing-Guide/mobileabsblkgranite.png" alt="Absolute Black Granite">
                        <img class="img-responsive mobile" src="images/Pricing-Guide/mobileunivers.png" alt="Univers Font">
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="pricing-area">
                    <div class="body-area-headline">KEEPSAKE REPLICAS</div>
                    <div class="pricing-area-images">
                        <img width="860" height="194" class="img-responsive desktop" src="images/Pricing-Guide/pricingguide03.png" alt="">
                        <img class="img-responsive mobile" src="images/Pricing-Guide/mobilereplica.png" alt="Keepsake Replica">
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="pricing-area">
                    <div class="body-area-headline">KEEPSAKE PLAQUES</div>
                    <div class="pricing-area-images">
                        <img width="860" height="194" class="img-responsive desktop" src="images/Pricing-Guide/pricingguide04.png" alt="">
                        <img class="img-responsive mobile" src="images/Pricing-Guide/mobileplaque.png" alt="Keepsake Plaque">
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="pricing-area">
                    <div class="body-area-headline">SYMBOLS &amp; GREEK CHARACTERS</div>
                    <div class="pricing-area-images">
                        <img width="806" height="131" class="img-responsive desktop" src="images/Pricing-Guide/pricingguide05.png" alt="">
                        <img class="img-responsive mobile" src="images/Pricing-Guide/mobilesymbols.png" alt="Symbols and Greek Characters">
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="pricing-area">
                    <div class="body-area-headline">PROJECT &amp; DONOR LOGOS</div>
                    <div class="pricing-area-images">
                        <img width="819" height="144" class="img-responsive desktop" src="images/Pricing-Guide/pricingguide06.png" alt="">
                        <img class="img-responsive mobile" src="images/Pricing-Guide/mobilelogos.png" alt="Project and Donor Logos">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/jsx">
    // import ImageMap from 'image-map';
    export default {
        name: 'pricing-guide',
        components: {
        },
        metaInfo: {
            title: 'Pricing Guide',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: ''
                }
            ]
        },
        mounted: function () {
            // window.$('img[usemap]').imageMap();
            // console.log($('img[usemap]'));
            // var im = ImageMap('img[usemap]');
            // console.log(im);
        },
        beforeDestroy: function () {

        }
    }
</script>



// WEBPACK FOOTER //
// PricingGuide.vue?61b8e0fc